<template>
  <div class="bg">
    <div class="box">
      <div class="logo center-top">
        <img src="./imgs/motul-logo.svg" />
      </div>
      <div class="info center-top">
        <div class="status">
          <img src="./imgs/img2.png" />
        </div>
        <div class="title">{{ $t("verification.titleText") }}</div>
        <div class="content">{{ $t("verification.infoText") }}</div>
        <div class="product pd">
          <div>{{ $t("verification.productText") }}{{ $t(modelCode) }}</div>
          <div class="mt-10">{{ $t("verification.batchText") }}</div>
        </div>
        <div class="btn" v-on:click="btn">{{ $t("verification.btnText") }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    //const that = this;
    return {
      modelCode: "", //产品型号
      serialNub: "", //编码
      linkurl: "",
    };
  },
  mounted() {
    function getURLParameter(name) {
      //获取参数值
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    }
    const modelCode = getURLParameter("m"); //获取型号
    const serialNub = getURLParameter("s"); //获取编码
    if (modelCode != "" && modelCode != null) {
      this.modelCode = "model" + modelCode;
    } else {
      this.modelCode = modelCode;
    }
    this.serialNub = serialNub;
    this.linkurl = "https://www.motul.com/";
  },
  methods: {
    btn() {
      if (this.modelCode != "" && this.modelCode != null) {
        window.location.href = this.linkurl + this.$t("link" + this.modelCode);
      }
    },
  },
};
</script>

<style>
html {
  font-size: 15.3px !important;
}
</style>

<style scoped>
.bg {
  font-size: 15.3px !important;
  background: #000;
  -webkit-text-size-adjust: 100%;
}
.box {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  padding-bottom: 2.5rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #000;
  overflow: hidden;
}

.logo {
  width: 7.6875rem;
  height: 2.1875rem;
  img {
    width: 100%; /* 添加：图片宽度填满容器 */
    height: 100%; /* 添加：图片高度填满容器 */
    object-fit: cover; /* 添加：保持比例裁剪居中 */
  }
}

.info {
  width: 21.375rem;
  min-height: 34.0625rem;
  background: #fff;
  padding-bottom: 11.875rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}

.center-top {
  margin: 0 auto;
  margin-top: 1.4375rem;
}

.btn {
  width: 14.75rem;
  height: 2.5rem;
  background: #ed1d24;
  border-radius: 0.3125rem;
  font-family: Graphik;
  font-weight: 600;
  font-size: 1rem;
  color: #fff;
  text-align: center;
  line-height: 2.5rem;
  position: absolute;
  left: 50%;
  margin-left: -7.375rem; /* 确保这个值是宽度的一半（14.75 ÷ 2 = 7.375） */
  bottom: 5rem;
}

.status {
  width: 5.0625rem;
  height: 5.0625rem;
  border-radius: 50%;
  margin: 0 auto;
  margin-top: 2.5rem;
  margin-bottom: 0.875rem;
}
.status img {
  width: 100%; /* 添加：图片宽度填满容器 */
  height: 100%; /* 添加：图片高度填满容器 */
  object-fit: cover; /* 添加：保持比例裁剪居中 */
}

.title {
  font-family: Graphik;
  font-weight: 900;
  font-size: 1.4375rem;
  color: #000;
  text-align: center;
  margin-bottom: 0.875rem;
}
.content {
  width: 19.375rem;
  font-family: math;
  font-weight: 400;
  font-size: 0.9rem;
  color: #000;
  margin: 0 auto;
}

.pd {
  width: 19.375rem;
  font-family: math;
  font-weight: 400;
  font-size: 0.95rem;
  color: #000;
  margin: 0 auto;
}

.product {
  margin-top: 1.375rem;
  padding-top: 2rem;
  box-sizing: border-box;
  border-top: 0.0625rem solid #c9c9c9;
}
.mt-10 {
  margin-top: 0.5rem;
}
</style>
